import { Middleware } from "redux";

import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { Locale } from "@com.mgmtp.a12.utils/utils-localization/lib/main";

import { ArchiveModuleFormDescriptor } from "../descriptors";
import { isArchiveModalDocumentData } from "../archiveModalTypes";

export const revokeArchiveUrlBeforeCancelMiddleware: Middleware<unknown, { locale: Locale }> = api => next => {
	return action => {
		if (!ActivityActions.cancel.match(action)) {
			return next(action);
		}

		const eldoradoModalActivity = ActivitySelectors.activityById(action.payload.activityId)(api.getState());
		if (!eldoradoModalActivity || !ArchiveModuleFormDescriptor.isInstance(eldoradoModalActivity.descriptor)) {
			return next(action);
		}

		const data = ActivitySelectors.data(eldoradoModalActivity.id)(api.getState());
		if (isArchiveModalDocumentData(data) && data.document.root.metadata?.archivePreviewUrl) {
			URL.revokeObjectURL(data.document.root.metadata?.archivePreviewUrl);
		}

		return next(action);
	};
};
